import { BaseOnboardingCard } from "@/ui/components/onboarding/v2/cards/BaseOnboardingCard";
import { Box } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";

// Placeholder -- content not final
const VideoPreviewHeight = 72;

const OnboardingVideoPreviewCard = ({ testID }: ViewWithTestID) => (
  <BaseOnboardingCard
    borderColor={ColorToken.TertiaryMarigoldBackground}
    testID={testID}
  >
    <Box height={VideoPreviewHeight} />
  </BaseOnboardingCard>
);

export { OnboardingVideoPreviewCard };
